import { z } from "zod";
import type { Operation } from "../types";

// Data ownership & residency (PRD §3, M3) — portable workspace export for the
// "you already own your data, no graduation" download.

const exportResponse = z.object({
  manifest: z.object({
    workspace_id: z.number(),
    exported_at: z.string(),
    format: z.literal("excellent-workspace-export@1"),
    tables: z.array(z.string()),
    counts: z.record(z.number()),
  }),
  data: z.record(z.array(z.unknown())),
});
export type ExportResponse = z.infer<typeof exportResponse>;

// coverage-ignore: Hono port deferred after RO-10-09 Next delete; contract retained for apiKey
const exportOp: Operation<void, void, void, ExportResponse> = {
  method: "GET",
  path: () => "/api/workspace/export",
  response: exportResponse,
};

export const residency = {
  export: exportOp,
};
